import React from 'react';
import UserStack from 'App/components/UserStack';

export default function AccountManagerColumn({ account, createNewAccountRow }) {
	if (!account.users) {
		return null;
	}

	const Component = !createNewAccountRow ? 'div' : 'td';

	return (
		<Component className={`DataSourceColumn accountManager ${!createNewAccountRow ? 'align-items-center' : ''}`}>
			<UserStack users={account.users} />
		</Component>
	);
}
